import IHttpMonitorsExportRequest from 'features/http/model/HttpMonitor/IHttpMonitorsExportRequest';
import {stringToBoolean} from 'shared/lib/filterHelper';

import type {
    IHttpMonitorFiltersForm,
} from '../ui/HttpMonitor/HttpMonitorsFilters/HttpMonitorFiltersForm/HttpMonitorFiltersForm';

export function buildHttpMonitorsExportRequest(
    {name, url, status, ok, tags, days, orderBy}: IHttpMonitorFiltersForm,
): IHttpMonitorsExportRequest {
    const data: IHttpMonitorsExportRequest = {};

    if (name) {
        data.name = name;
    }

    if (url) {
        data.url = url;
    }

    if (status) {
        data.status = status;
    }

    if (ok !== null && ok !== undefined) {
        data.ok = stringToBoolean(ok);
    }

    if (tags && tags.length > 0) {
        data.tags = tags;
    }

    if (days !== undefined && days !== null) {
        data.days = Number(days);
    }

    if (orderBy?.field) {
        data.order_by = orderBy;
    }

    return data;
}
